import { DEPART_DIRECTION } from './constants';

function serializeFilterParams(params = {}) {
    const {
        direction,
        originPlaceId,
        destinationPlaceId,
    } = params;

    if (!originPlaceId || !destinationPlaceId) {
        return;
    }

    if (direction === DEPART_DIRECTION) {
        return `${originPlaceId}-${destinationPlaceId}`;
    }

    return `${destinationPlaceId}-${originPlaceId}`;
}

function buildPSearchParams(direction, params = {}) {
    if (!params.originPlace || !params.destinationPlace) {
        return;
    }

    if (direction === DEPART_DIRECTION) {
        return {
            direction,
            departDatetime: params.departDate,
            destinationPlaceId: params.destinationPlace.place_id,
            destinationGeometry: params.destinationPlace.geometry,
            destinationAddressComps: params.destinationPlace.address_components,
            destinationText: params.destinationPlace.formatted_address,
            originPlaceId: params.originPlace.place_id,
            originGeometry: params.originPlace.geometry,
            originAddressComps: params.originPlace.address_components,
            originText: params.originPlace.formatted_address,
            locale: params.locale,
            currency: params.currency,
            seoReferrer: params.seoReferrer,
        };
    }

    return {
        direction,
        departDatetime: params.returnDate,
        destinationPlaceId: params.originPlace.place_id,
        destinationGeometry: params.originPlace.geometry,
        destinationAddressComps: params.originPlace.address_components,
        destinationText: params.originPlace.formatted_address,
        originPlaceId: params.destinationPlace.place_id,
        originGeometry: params.destinationPlace.geometry,
        originAddressComps: params.destinationPlace.address_components,
        originText: params.destinationPlace.formatted_address,
        locale: params.locale,
        currency: params.currency,
        seoReferrer: params.seoReferrer,
    };
}

export {
    buildPSearchParams,
    serializeFilterParams,
};
